export default {
  config: {
    method: "users/",
    title: "Пользователи",
    objectName: "Пользователь",
    disableDelete: true,
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "80px",
    },
    created_at: {
      default: "",
      type: "datetime",
      title: "Создан",
      preset: true,
    },
    updated_at: {
      default: "",
      type: "datetime",
      title: "Обновлен",
      preset: true,
    },
    name: {
      default: "",
      type: "text",
      title: "Имя",
      width: "auto",
    },
    email: {
      default: "",
      type: "text",
      title: "Email",
    },
    password: {
      default: "",
      type: "text",
      title: "Пароль",
    },
    pachca_id: {
      default: "",
      type: "text",
      title: "ID в Пачке",
    },
    admin: {
      default: "",
      type: "checkbox",
      title: "Админ",
      width: "auto",
    },
    active: {
      default: "",
      type: "checkbox",
      title: "Активен",
      width: "auto",
    },
  }
};
